import { useMutation, useQueryClient } from "@tanstack/react-query";

import { entityKeys } from "../queryKeys";
import { deleteEntityBranch, updateEntityBranch } from "../services/branch.service";

export const useDeleteEntityBranch = (onSuccess?: (data: any, branchId: string) => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (branchId: string) => deleteEntityBranch(branchId),
    onSuccess: (data, branchId) => {
      queryClient.invalidateQueries({
        queryKey: entityKeys.branch(branchId),
      });
      queryClient.invalidateQueries({
        queryKey: entityKeys.locationsByCountry,
      });
      if (onSuccess) onSuccess(data, branchId);
    },
  });
};

export const useUpdateEntityBranch = (branchId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => updateEntityBranch(branchId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: entityKeys.branch(branchId),
      });

      queryClient.invalidateQueries({
        queryKey: entityKeys.locationsByCountry,
      });
    },
  });
};
